import { openPopup } from '@telegram-apps/sdk-react';
import { insideTelegram, safe } from './env';
import { t } from '@/i18n';

/** Нативное подтверждение Telegram, с откатом на window.confirm вне клиента. */
export async function confirmAction(
  message: string,
  { title = t('lib.confirm.title'), okText = t('lib.confirm.delete') }: { title?: string; okText?: string } = {},
): Promise<boolean> {
  if (insideTelegram() && safe(() => openPopup.isAvailable())) {
    try {
      const pressed = await openPopup({
        title,
        message,
        buttons: [
          { id: 'cancel', type: 'cancel' },
          { id: 'ok', type: 'destructive', text: okText },
        ],
      });
      return pressed === 'ok';
    } catch {
      /* клиент не смог — спросим по-браузерному */
    }
  }
  return window.confirm(message);
}
